/**
 * Page - Cart JS
 */

// CSS
import styles from '../scss/page-cart.scss';

const $ = window.jQuery;
